(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7345],{

/***/ 81560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Products; }
/* harmony export */ });
/* harmony import */ var components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80819);
/* harmony import */ var components_blocks_Container__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75046);
/* harmony import */ var layouts_Default__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87607);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_cards_CategoryCard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22573);
/* harmony import */ var components_blocks_ItemGrid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57731);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);










var __N_SSP = true;
function Products(props) {
  var categories = props.categories;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();

  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function () {// console.log('categ: ', JSON.stringify(categories))
  }, []);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components_blocks_Container__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components_blocks_ItemGrid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        t: t,
        title: t('home:product_browsebycategory'),
        items: categories,
        render: function render(item) {
          return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components_cards_CategoryCard__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            categoryLevel: 1,
            data: item,
            baseUrl: '/products',
            cardType: 'product',
            t: t
          }, item.slug);
        }
      })
    }), categories.map(function (cat) {
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components_blocks_Container__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        className: "mt-16",
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components_blocks_ItemGrid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          t: t,
          title: t("home:".concat(cat.slug)),
          href: "/products/".concat(cat.slug),
          items: cat.subcategories && cat.subcategories.length >= 4 ? cat.subcategories.slice(0, 4) : cat.subcategories,
          render: function render(item) {
            return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components_cards_CategoryCard__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              categoryLevel: 2,
              data: item,
              baseUrl: '/products',
              cardType: 'product',
              t: t
            }, item.slug);
          }
        })
      }, cat.slug);
    })]
  });
}

Products.getLayout = function getLayout(page) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(layouts_Default__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    children: page
  });
};

/***/ }),

/***/ 83308:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products",
      function () {
        return __webpack_require__(81560);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,196,7607,5531,9774,2888,179], function() { return __webpack_exec__(83308); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);